import axios from 'axios';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import warning3 from '../../assets/images/backoffice/warning3.png';
import { Checkbox } from '../../components/common/Checkbox/Checkbox';
import { SETTINGS_VIRTUAL_OFFICE } from '../../routes/routes';
import { H3, P2 } from '../../styles/FontStyles';
import { Button, Flexed } from '../../styles/GlobalComponents';
import { colors } from '../../styles/GlobalStyles';

export const FirstLogin = ({ history }: RouteComponentProps) => {
  const { t } = useTranslation('onboarding');
  const { t: dashboard } = useTranslation('dashboard');
  const [checkbox, setCheckbox] = useState(false);

  const firstLogin = async () => {
    try {
      await axios.put(`/user/set-first-login-popup-checked`);
      history.push(SETTINGS_VIRTUAL_OFFICE);
    } catch (error: any) {
      console.log(error.response);
    }
  };

  const dispatch = useDispatch();
  return (
    <div>
      <Flexed justifyCenter>
        <img src={warning3} alt='' style={{ width: 150 }} />
      </Flexed>

      <H3 center m='32px 0 10px 0'>
        {t('first_login.title')}
      </H3>

      <P2 m='32px 0'>
        {t('first_login.text1')} <b>{t('first_login.text2')}</b>
        <br />
        <b>{t('first_login.text3')}</b>
      </P2>

      <P2 mb='32'>&#x274C; Full Bonuses ( Direct Bonus) </P2>

      <Flexed mb='40' center>
        <Checkbox
          margin={'0 20px 0 0'}
          checked={checkbox}
          onClick={() => setCheckbox(!checkbox)}
        />
        <P2 color={colors.neutral700}>
          I am aware, that without BO subscription I can lose Direct bonuses
        </P2>
      </Flexed>

      <Button disabled={!checkbox} onClick={firstLogin}>
        {t('first_login.button')}
      </Button>
    </div>
  );
};
